function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("rect", {
  x: 24,
  width: 24,
  height: 24,
  rx: 12,
  transform: "rotate(90 24 0)",
  fill: "#004152"
});

var _ref3 = React.createElement("path", {
  d: "M7.12302 10.8839C6.9603 10.7211 6.9603 10.4573 7.12302 10.2946L7.71227 9.70535C7.87499 9.54263 8.13881 9.54263 8.30153 9.70535L12 13.4039L15.6986 9.70535C15.8613 9.54264 16.1251 9.54264 16.2878 9.70535L16.8771 10.2946C17.0398 10.4573 17.0398 10.7211 16.8771 10.8839L12.2956 15.4653C12.2139 15.5471 12.1066 15.5877 11.9995 15.5874C11.8927 15.5875 11.7859 15.5468 11.7045 15.4653L7.12302 10.8839Z",
  fill: "white"
});

var SvgChevronDownInCircleFill = function SvgChevronDownInCircleFill(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChevronDownInCircleFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevron-down-in-circle-fill.c79709b4.svg";
export { ForwardRef as ReactComponent };